/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("OnLayoutUIBehavior", ["UIBehaviorBase"], function (context, cls) {
  /**
   * @class OnLayoutUIBehavior
   * @memberOf classes
   * @extends classes.UIBehaviorBase
   */
  cls.OnLayoutUIBehavior = context.oo.Singleton(cls.UIBehaviorBase, function ($super) {
    return /** @lends classes.OnLayoutUIBehavior.prototype */ {
      /** @type {string} */
      __name: "OnLayoutUIBehavior",
      /**
       * @inheritDoc
       */
      _attachWidget: function (controller, data) {
        let node = controller.getAnchorNode();
        data.afterLayoutHandler = node.getApplication().layout.afterLayout(this._onLayout.bind(this, controller, data));

        let widget = controller.getWidget();
        if (widget) {
          data.layoutHandler = widget.when(context.constants.widgetEvents.layout, this._onLayout.bind(this, controller, data));
        }
      },
      /**
       * @inheritDoc
       */
      _detachWidget: function (controller, data) {
        if (data.afterLayoutHandler) {
          data.afterLayoutHandler();
          data.afterLayoutHandler = null;
        }
        if (data.layoutHandler) {
          data.layoutHandler();
          data.layoutHandler = null;
        }
      },

      /**
       * On layout widget event: send new page size to vm
       * @private
       */
      _onLayout: function (controller, data) {
        let widget = controller.getWidget();

        // @refactorme : Review this system, the isVisibleRecursively should be enough.
        let isVisible = widget.isElementInDOM() && widget.isVisibleRecursively();
        let pageWidget = widget.getPageWidget();
        if (pageWidget) {
          isVisible = isVisible && pageWidget.isVisible() && pageWidget.isCurrent();
        }
        // if widget is in a page which is not visible it is not necessary to send a pageSize
        if (!isVisible || !widget.getDataAreaHeight || !widget.getRowHeight) {
          return;
        }
        let dataAreaHeight = widget.getDataAreaHeight();
        let rowHeight = widget.getRowHeight();
        if (Number.isNaN(dataAreaHeight) || dataAreaHeight <= 0 || rowHeight <= 0) {
          return;
        }
        let newPageSize = Math.floor(dataAreaHeight / rowHeight + 0.1); // add 0.1 for values like 9,99
        newPageSize = Number.isNaN(newPageSize) ? 1 : Math.max(newPageSize, 1);
        // Add 2 to the buffer size for the drag and drop to work when droping after the last row
        let newBufferSize = newPageSize + 2;

        let node = controller.getAnchorNode();
        let app = node.getApplication();

        // Only send a page size change when idle: while the VM is processing (the layout now runs
        // between AUI batches during a refresh() loop) the command can't be sent and would pile up
        // until the loop ends. Matches OnLayoutPagedUIBehavior.
        if (!app?.isIdle() || app.scheduler.hasPendingFunctionCallResultCommands(true)) {
          return;
        }
        let pageSize = node.attribute("pageSize");
        let bufferSize = node.attribute("bufferSize");
        if (pageSize !== newPageSize || bufferSize !== newBufferSize) {
          app.scheduler.pageSizeVMCommand(node, newPageSize, newBufferSize);
        }
      }
    };
  });
});
